import React, { createRef, useEffect, useRef } from 'react';
import { Grid, Flex, AspectRatio, Text, Box, Image, Spinner } from '@chakra-ui/react';
// @ts-ignore
import PrismaZoom from 'react-prismazoom';
import TopPanelGame from './TopPanelGame/topPanelGame';
import BuyGame from './BuyGame/buyGame';
import { MockupScreenshots } from './MockupScreenshots/mockupScreenshots';
import { Color } from 'src/theme/color';
import { useFormikContext } from 'formik';

interface IMockupZoom {
	x: number;
	y: number;
	width: number;
	height: number;
}

export const ZoomGameMockUp = ({
	bgColor,
	ctaColor,
	textColor,
	name,
	screenshots,
	nameActive,
	description,
	video,
	zoom,
	gameCover,
}: {
	description?: string;
	bgColor?: string;
	ctaColor?: string;
	textColor?: string;
	video: string;
	name?: string;
	zoom?: IMockupZoom;
	screenshots: string[];
	nameActive?: boolean;
	gameCover?: string;
}) => {
	const prismaZoom = useRef(false);
	const { values } = useFormikContext();

	useEffect(() => {
		if (zoom && prismaZoom) {
			(prismaZoom as any).current
				? setTimeout(() => (prismaZoom as any).current.zoomToZone(zoom.x, zoom.y, zoom.width, zoom.height), 250)
				: '';
		}
	}, [prismaZoom.current]);

	return (
		<Grid
			overflow="hidden"
			maxH="500px"
			maxW="900px"
			bg={bgColor}
			borderRight="1px solid"
			borderColor={Color.GRAY_1}
		>
			<PrismaZoom ref={prismaZoom}>
				{(props => {
					console.log((PrismaZoom as any).current);
					return (
						<Flex
							p="34px 16px 16px 44px"
							direction="column"
							gridGap="36px"
							color={textColor ?? 'white'}
							bgColor={bgColor ?? 'transparent'}
						>
							<Flex>
								<TopPanelGame
									name={name ? name : 'Game Name'}
									nameActive={nameActive}
									cover={(values as any).media.cover ?? '/assets/default/default-cover-game.png'}
								/>
							</Flex>
							<Grid
								justifyContent="space-between"
								templateColumns="1fr 270px"
								gridGap="50px"
							>
								<Flex flexDirection="column">
									{((values as any).video != '' || (values as any).screenshots.length > 0) && (
										<MockupScreenshots
											color={ctaColor}
											video={video}
											screens={screenshots}
										/>
									)}

									<Flex
										pt="18px"
										w="100%"
										flexDirection="column"
										gridGap="10px"
										minH="200px"
									>
										<Text
											fontSize="14px"
											fontWeight="600"
											textTransform="uppercase"
										>
											About the game
										</Text>
										<Text
											fontSize="10px"
											fontWeight="400"
										>
											{description
												? description
												: 'Chodziło mu pewnie o to, że na Węgrzech może wygrać tylko polityk konserwatywny. Orbán jest do pokonania nawet na swoim własnym podwórku, choć warunki ku temu, delikatnie mówiąc, nie są idealne. Będąc 11 lat u władzy, przekształcił naszą demokrację w reżim autorytarny. Zmienił prawo wyborcze, przerysował na swoją korzyść mapę wyborczą. Zrobił to oczywiście bez pytania opozycji o zdanie. Żeby go więc odsunąć od władzy, trzeba zaoferować wiarygodną alternatywę dla tej części elektoratu, która głosuje na niego od 2010 roku, ale zaczyna już mieć dość rządów Fideszu. Ci wyborcy nie poparliby jednak lewicowego kandydata na czele opozycji.'}
										</Text>
									</Flex>
								</Flex>
								<Flex
									flexDirection="column"
									gridGap="8px"
								>
									<Box
										w="100%"
										position="relative"
										pb="22px"
										h="170px"
									>
										<Image
											src={`/assets/brand/cartridges/${
												(values as any).cartridge == 'gold' ? 'Golden.png' : 'Gray.png'
											}`}
										/>
										<Box
											zIndex="999999"
											bgColor="black"
											w="155px"
											h="88px"
											position="absolute"
											top="-13%"
											left="22%"
											transform="translateY(50%)"
											backgroundImage={(values as any).media.cover}
											backgroundSize="cover"
											justifyContent="center"
											alignItems="center"
										></Box>
										<Box
											w="155px"
											h="88px"
											position="absolute"
											top="-13%"
											left="22%"
											transform="translateY(50%)"
											backgroundImage={gameCover}
											backgroundSize="cover"
											justifyContent="center"
											alignItems="center"
											filter="blur(36px)"
										/>
									</Box>
									<BuyGame ctaColor={ctaColor ?? 'gray'} />
								</Flex>
							</Grid>
						</Flex>
					);
				})()}
			</PrismaZoom>
		</Grid>
	);
};

export default ZoomGameMockUp;
